import api from '../../infra/api'

const fields = `[
"Id",
"CodigoVisual",
"CodigoResponsavelTecnico",
"CodigoTipoProjeto",
"Protocolo",
"Situacao",
"DataCadastro",
"PrazoAnaliseConsulta",
"PrazoAnaliseDoc",
"DataAprovacaoDoc",
"CodigoUc",
"TipoInscricao",
"Inscricao",
"Nome",
"Email",
"TelefoneCelular",
"TelefoneCelularAlt",
"RamoAtividade",
"DemandaCalculada",
"NomeLoteamento",
"QuantidadeLotes",
"QuantidadeMedidoresUC",
"Endereco",
"Cep",
"CodigoCidade",
"Cidade",
"Rua",
"NumeroEnd",
"Complemento",
"Uf",
"Longitude",
"Latitude",
"TipoProjeto",
"RespTecnico"
]`;

class ServConsultaPrevia {
    async listar(codigoResp, filtro = "") {
        const response = await api({
            method: "GET",
            url: filtro.trim() === ""
                ? `/api/v1/ConsultaPrevia?page=1&start=0&limit=999&fields=${fields}&sort=[{"property":"CodigoVisual","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","value":"${codigoResp}","and":true,"not":false}]`
                : `/api/v1/ConsultaPrevia?page=1&start=0&limit=999&fields=${fields}&sort=[{"property":"CodigoVisual","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","value":"${codigoResp}","and":true,"not":false}]`
        });

        return response.data;
    }

    async listarCFiltroCode(codigoResp, filtro) {
        const response = await api({
            method: "GET",
            url: !filtro || filtro === 0
                ? `/api/v1/ConsultaPrevia?page=1&start=0&limit=999&fields=${fields}&sort=[{"property":"CodigoVisual","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","value":"${codigoResp}","and":false}]`
                : `/api/v1/ConsultaPrevia?page=1&start=0&limit=999&fields=${fields}&sort=[{"property":"CodigoVisual","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","value":"${codigoResp}","and":true,"not":false},{"property":"CodigoVisual","operator":"equal","value":"${filtro}","and":true}]`
        });

        return response.data;
    }

    async listarCFiltros(codigoResp, pesquisaGeral) {
        let url = `/api/v1/ConsultaPrevia?page=1&start=0&limit=999&fields=${fields}&sort=[{"property":"CodigoVisual","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","value":"${codigoResp}","and":true,"not":false}]`;

        if (pesquisaGeral && pesquisaGeral.trim() !== "") {
            url = url.slice(0, -1);

            url += `,{"property":"Nome","operator":"containsall","value":"${pesquisaGeral}"}` +
                `,{"property":"Inscricao","operator":"containsall","value":"${pesquisaGeral}","and":false}` +
                `,{"property":"Protocolo","value":"${pesquisaGeral}","and":false}` +
                `,{"property":"CodigoVisual","value":"${pesquisaGeral}","and":false}` +
                `,{"property":"Email","operator":"containsall","value":"${pesquisaGeral}","and":false}` +
                `,{"property":"TelefoneCelular","value":"${pesquisaGeral}","and":false}]`;
        }

        const response = await api({
            method: "GET",
            url: url
        });

        return response.data;
    }

    async listarCfeSituacaoOuData(codigoResp, pesquisaGeral, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal) {
        let filter = this.retornaFilterDeAcordoComFiltros(codigoResp, pesquisaGeral, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal);
    
        let url = !filter || filter.trim() === ""
            ? `/api/v1/ConsultaPrevia?page=1&start=0&limit=999&fields=${fields}&sort=[{"property":"CodigoVisual","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","value":"${codigoResp}","and":true,"not":false}]`
            : `/api/v1/ConsultaPrevia?page=1&start=0&limit=999&fields=${fields}&sort=[{"property":"CodigoVisual","direction":"DESC"}]&filter=${filter}`;
    
        const response = await api({
            method: "GET",
            url: url
        });
    
        return response.data;
    }

    retornaFilterDeAcordoComFiltros(codigoResp, pesquisaGeral, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal) {
        let temPesquisaGeral = pesquisaGeral && pesquisaGeral.trim() !== "";
    
        if (temPesquisaGeral) {
            let filtroSituacaoDatas = this.handleFiltrosSituacaoOuDatas(codigoResp, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal);
            let filtroFinal = filtroSituacaoDatas ? "," + filtroSituacaoDatas.slice(1, -1) : "";
    
            return `[{"property":"Nome","operator":"containsall","value":"${pesquisaGeral}","and":false}, {"property":"Protocolo","operator":"equal","value":"${pesquisaGeral}","and":false}, {"property":"Inscricao","operator":"containsall","value":"${pesquisaGeral}","and":false},{"property":"Email","operator":"containsall","value":"${pesquisaGeral}","and":false},{"property":"TelefoneCelular","value":"${pesquisaGeral}","and":false},{"property":"CodigoVisual","value":"${pesquisaGeral}","and":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false}${filtroFinal}]`;
        } else {
            return this.handleFiltrosSituacaoOuDatas(codigoResp, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal);
        }
    }

    handleFiltrosSituacaoOuDatas(codigoResp, codigo, situacao, tipoDataFiltro, dataInicial, dataFinal) {
        let temSituacaoInformada = situacao && situacao.length > 0;
        let temPeriodoInformado = (dataInicial && dataInicial.toLocaleDateString() !== "") && (dataFinal && dataFinal.toLocaleDateString() !== "");
        let arraySituacaoFormatada = JSON.stringify(situacao || []);
        
        let campoParaFiltrarData = (tipoDataFiltro === "data-cadastro") 
            ? "DataCadastro" 
            : "PrazoAnaliseConsulta";
    
        if (temSituacaoInformada && !temPeriodoInformado) {
            return `[{"property":"CodigoVisual","operator":"equal","value":"${codigo}","and":true,"not":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"Situacao","operator":"in","value":${arraySituacaoFormatada},"and":true,"not":false}]`
        } 
        else if (!temSituacaoInformada && temPeriodoInformado) {
            return `[{"property":"CodigoVisual","operator":"equal","value":"${codigo}","and":true,"not":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"${campoParaFiltrarData}","operator":"greaterOrEqual","value":"${dataInicial.toLocaleDateString()}","and":true},{"property":"${campoParaFiltrarData}","operator":"lessOrEqual","value":"${dataFinal.toLocaleDateString()}","and":true}]`
        } 
        else {
            return `[{"property":"CodigoVisual","operator":"equal","value":"${codigo}","and":true,"not":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"Situacao","operator":"in","value":${arraySituacaoFormatada},"and":true,"not":false},{"property":"${campoParaFiltrarData}","operator":"greaterOrEqual","value":"${dataInicial ? dataInicial.toLocaleDateString() : "01/01/1900"}","and":true},{"property":"${campoParaFiltrarData}","operator":"lessOrEqual","value":"${dataFinal ? dataFinal.toLocaleDateString() : "01/01/1900"}","and":true}]`
        }
    }

    async Inserir (dto) {
        const response = await api({
            method: "POST",
            url: "api/v1/ConsultaPrevia",
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    async Editar (dto) {
        const response = await api({
            method: "PUT",
            url: `api/v1/ConsultaPrevia`,
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    async RecuperarParaEditar(codigoConsulta) {
        const response = await api({
            method: "GET",
            url: `api/v1/ConsultaPrevia/${codigoConsulta}`
        });

        return response.data;
    }

    async RecuperarDadosDoConsumidor(dto) {
        const response = await api({
            method: "POST",
            url: "api/v1/UC/DadosDoConsumidorSol",
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    async RecuperarArquivamento (codigoConsulta) {
        const response = await api({
            method: "GET",
            url: `api/v1/ConsultaPrevia/RecuperarArquivamento/${codigoConsulta}`
        });
        
        return response.data;
    }

    async RecuperarTipoProjeto(filtro) {
        const response = await api({
            method: "GET",
            url: filtro.trim() === ""
            ? `api/v1/TipoProjeto?page=1&start=0&limit=999&fields=["Id","Ativo","Nome"]&filter=[{"property":"Ativo","operator":"in","value":[1]}]`
            : `api/v1/TipoProjeto?page=1&start=0&limit=999&fields=["Id","Ativo","Nome"]&filter=[{"property":"Ativo","operator":"in","value":[1]},{"property":"Nome","operator":"containsall","value":"${filtro}","and":false}]`
        });

        return response.data;
    }

    async InserirDocumentoNaConsulta(form) {
        const response = await api ({
            method: "POST",
            url: "/api/v1/ConsultaPreviaDocs/AdicionarAnexoNaConsulta",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: form
        });

        return response.data;
    }

    async RealizarDownloadDocumento (codigoDocumento) {
        const response = await api({
            method: "POST",
            url: "api/v1/ConsultaPreviaDocs/RealizarDownloadDocumento",
            data: {
                CodigoDocumento: codigoDocumento
            }
        });

        return response.data;
    }

    async RemoverDocumento(codigoDocumento) {
        const response = await api({
            method: "DELETE",
            url: `api/v1/ConsultaPreviaDocs/RemoverDocumento/${codigoDocumento}`
        });

        return response.data;
    }

    async EnviarParaAnalise(codigo){
        const response = await api({
            method: "PUT",
            url: `api/v1/ConsultaPrevia/EnviarParaAnalise/${codigo}`,
        });

        return response.data;
    }

    async ArquivarConsulta(dto){
        const response = await api({
            method: "PUT",
            url: "api/v1/ConsultaPrevia/Arquivar",
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    async listarDocumentosPorConsultaPrevia(codigoConsultaPrevia) {
        const response = await api({
            method: "GET",
            url: `/api/v1/ConsultaPreviaDocs?page=1&start=0&limit=999&filter=[{"property":"CodigoConsultaPrevia","operator":"equal","value":"${codigoConsultaPrevia}","and":true,"not":false}]`
        });
    
        return response.data;
    }
}

export default new ServConsultaPrevia();